export default __webpack_public_path__ + "static/media/roadmap-m.d7f2f688.svg";